export default __webpack_public_path__ + "static/media/stockeer2.aa1cd80e.png";